import { render, staticRenderFns } from "./BcPrice.vue?vue&type=template&id=2629062e"
import script from "./BcPrice.vue?vue&type=script&lang=js"
export * from "./BcPrice.vue?vue&type=script&lang=js"
import style0 from "./BcPrice.vue?vue&type=style&index=0&id=2629062e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports